module.exports = __webpack_public_path__ + "static/media/airlines.ef72b174.svg";